module.exports = __webpack_public_path__ + "static/img/env21.1991df7.png";


//////////////////
// WEBPACK FOOTER
// ./src/module/technology/images/env21.png
// module id = 49
// module chunks = 4